import moment from "moment"
import { DATE_FORMAT } from "./constant"

export const createURL = (url: string, params: any) => {
    Object.keys(params).map((param) => {
        url = url.replace(`:${param}`, params[param])
    })
    return url
}


export const UpdateWithVariables = (url: string, data: any) => {
    if (data) {
        let dynamicParams = url.match(/:[A-Z_]*/gi)
        dynamicParams?.map(key => {
            if (key.length > 1) url = url.replace(key, data[key.replace(':', '')])
        })
    }
    return url
}

export function CheckNumber(e: { target: { value: string; getAttribute: (arg0: string) => string } }) {
    let n = e.target.value.replace(/^0+/, '').replace(/[^\d.]/g, '')
    const min: number = parseFloat(e.target.getAttribute('min'))
    const max: number = parseFloat(e.target.getAttribute('max'))
    if (n == '') {
        n = '0'
    }
    if (min && parseFloat(n) < min) {
        n = String(min)
    }

    if (max && parseFloat(n) > max) {
        n = String(max)
    }
    e.target.value = n
}

export const showDate = (dbDate: any, dateFormat: any = DATE_FORMAT) => {
    return (dbDate !== '') ? moment(dbDate).format(dateFormat) : "";
}
 
export const getSelectedOption = (selectedValue: string | number, options: any[],matchWidth:string = 'value') => {
    let selected: any = null
    options.map((option: any, i: number) => {
        if (option[matchWidth] == selectedValue) {
            if(!selected)
            selected = option
        }
    })
    return selected
}
export const getSelectedOptions = (selectedValues: string[] | number[] | null, options: any[]) => {
    const selected: any[] = []
    selectedValues?.map((value) => {
        selected.push(getSelectedOption(value, options))
    })
    return selected
}

export const downloadExcel = (data: any, fileName: string) => {
    const blob = new Blob([data], { type: 'application/vnd.ms-excel ' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${fileName}.xlsx`;
    a.click();
    window.URL.revokeObjectURL(url);
}
export const downloadPDF = (data: any, fileName: string) => {
    const blob = new Blob([data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName + '.pdf';
    a.click();
    window.URL.revokeObjectURL(url);
}

